var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 6.66667V10C10.6667 10.3667 10.3667 10.6667 10 10.6667H2C1.63333 10.6667 1.33333 10.3667 1.33333 10V6.66667C1.33333 6.3 1.03333 6 0.666667 6C0.3 6 0 6.3 0 6.66667V10.6667C0 11.4 0.6 12 1.33333 12H10.6667C11.4 12 12 11.4 12 10.6667V6.66667C12 6.3 11.7 6 11.3333 6C10.9667 6 10.6667 6.3 10.6667 6.66667ZM6.66667 6.44667L7.92 5.19333C8.18 4.93333 8.6 4.93333 8.86 5.19333C9.12 5.45333 9.12 5.87333 8.86 6.13333L6.46667 8.52667C6.20667 8.78667 5.78667 8.78667 5.52667 8.52667L3.13333 6.13333C2.87333 5.87333 2.87333 5.45333 3.13333 5.19333C3.39333 4.93333 3.81333 4.93333 4.07333 5.19333L5.33333 6.44667V0.666667C5.33333 0.3 5.63333 0 6 0C6.36667 0 6.66667 0.3 6.66667 0.666667V6.44667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadNew);
export default __webpack_public_path__ + "static/media/downloadNew.387acca06bd756d5d6d572535cad12bb.svg";
export { ForwardRef as ReactComponent };